import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Number$isFinite from "@babel/runtime-corejs3/core-js/number/is-finite";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { computed, defineComponent, ref } from "@vue/composition-api";
import i18n from "@Shared/@i18n";
import { CLIENT_APPLICATION_STATUS } from "@Shared/js/enum";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE } from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import { useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import AmortizationScheduleContainer from "@Broker/@Modules/financial-tools/mortgage-calculators/amortization-schedule-container.vue";
import MaximumMortgageContainer from "@Broker/@Modules/financial-tools/mortgage-calculators/maximum-mortgage-container.vue";
import MinimumIncomeContainer from "@Broker/@Modules/financial-tools/mortgage-calculators/minimum-income-container.vue";
import ScenarioBuilderContainer from "@Broker/@Modules/financial-tools/mortgage-calculators/scenario-builder-container.vue";
import { APPLICANT_INCOME_PERIOD, MORTGAGE_COMPOUNDING_PERIOD, MORTGAGE_FREQUENCY, MORTGAGE_LOAN_TYPE } from "@Shared/@Types/application/application-enums";
import { isEmpty } from "lodash";
export default defineComponent({
  name: "FinancialToolsTable",
  components: {
    vSelectField,
    AmortizationScheduleContainer,
    MaximumMortgageContainer,
    MinimumIncomeContainer,
    ScenarioBuilderContainer
  },
  props: {
    clientUsername: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    var _currentMortgageTypes;
    const {
      CURRENT_APPLICATION,
      CURRENT_APPLICATION_APPLICANTS,
      CURRENT_APPLICATION_PRINCIPAL_BORROWER,
      GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE,
      CALCULATED_VALUES_BY_MORTGAGE_TYPE,
      APPLICATION_STATUS
    } = useApplicationStoreGetters([ApplicationGetters.CURRENT_APPLICATION, ApplicationGetters.CURRENT_APPLICATION_APPLICANTS, ApplicationGetters.CURRENT_APPLICATION_PRINCIPAL_BORROWER, ApplicationGetters.GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE, ApplicationGetters.CALCULATED_VALUES_BY_MORTGAGE_TYPE, ApplicationGetters.APPLICATION_STATUS]);
    const {
      [ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE]: acceptedLenderSubmissions
    } = useApplicationStoreGetters([ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE]);
    const currentApplication = CURRENT_APPLICATION.value;
    const submissionDetails = currentApplication["submission-details"] || [];
    const currentMortgageTypes = _mapInstanceProperty(submissionDetails).call(submissionDetails, sub => {
      var _sub$submissionDetai;
      return sub == null ? void 0 : (_sub$submissionDetai = sub["submission-details"]) == null ? void 0 : _sub$submissionDetai["mortgage-type"];
    });
    const {
      mortgageTypeOptions
    } = APPLICATION_FIELD_OPTIONS();
    const mortgageTypeOptionsCur = ref([]);
    for (const cmt of currentMortgageTypes) {
      var _mortgageTypeOptions$;
      mortgageTypeOptionsCur.value.push((_mortgageTypeOptions$ = _findInstanceProperty(mortgageTypeOptions).call(mortgageTypeOptions, option => option.value === cmt)) != null ? _mortgageTypeOptions$ : mortgageTypeOptions[0]);
    }
    const aMortgageType = (_currentMortgageTypes = currentMortgageTypes[0]) != null ? _currentMortgageTypes : undefined;
    const handleMortgageTypeSelected = (row, val) => {
      row.selectedMortgageType = val.value;
    };
    const calculatorTypeRows = ref([{
      calculatorName: i18n.t("financial-tools.minimumIncomeRequired").toString(),
      selectedMortgageType: aMortgageType,
      component: MinimumIncomeContainer
    }, {
      calculatorName: i18n.t("financial-tools.amortizationSchedule").toString(),
      selectedMortgageType: aMortgageType,
      component: AmortizationScheduleContainer
    }, {
      calculatorName: i18n.t("financial-tools.maximumMortgage").toString(),
      selectedMortgageType: aMortgageType,
      component: MaximumMortgageContainer
    }, {
      calculatorName: i18n.t("financial-tools.scenarioBuilder").toString(),
      selectedMortgageType: aMortgageType,
      component: ScenarioBuilderContainer
    }]);
    const fields = [{
      key: "calculatorType",
      label: i18n.t("application-form.type").toString()
    }, {
      key: "mortgageType",
      label: i18n.t("application-form.mortgage-type").toString()
    }, {
      key: "action",
      label: ""
    }];
    const activeCalculator = ref(null);
    function getScenarioBuilderEligibility(mortgageType) {
      var _acceptedLenderSubmis, _calculatedValues$tot;
      if (APPLICATION_STATUS.value === CLIENT_APPLICATION_STATUS.completed) {
        return {
          eligible: false,
          reasons: [i18n.t("financial-tools.SbApplicationCompleted").toString()]
        };
      }
      const MIN_MORTGAGE_AMOUNT = 10_000;
      const MAX_MORTGAGE_AMOUNT = 100_000_000;
      const MIN_INTEREST_RATE = 0.5;
      const MAX_INTEREST_RATE = 25;
      const MIN_PERIOD_MONTHS = 1;
      const MAX_PERIOD_MONTHS = 480;
      const reasons = [];
      const subDetail = GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE.value(mortgageType);
      const sd = subDetail == null ? void 0 : subDetail["submission-details"];
      const calculatedValues = CALCULATED_VALUES_BY_MORTGAGE_TYPE.value(mortgageType);
      if (sd) {
        var _sd$interestRate, _sd$termYears, _sd$termMonths, _sd$amortizationYear, _sd$amortizationMont;
        const requiredFields = ["mortgage-type", "interest-rate", "frequency", "compounded-period"];
        const missing = _filterInstanceProperty(requiredFields).call(requiredFields, field => isEmpty(sd[field]));
        const hasTermValue = !isEmpty(sd["term-years"]) || !isEmpty(sd["term-months"]);
        const hasAmortizationValue = !isEmpty(sd["amortization-years"]) || !isEmpty(sd["amortization-months"]);
        const isInterestOnly = sd["interest-only"] === true;
        if (missing.length || !hasTermValue || !hasAmortizationValue) {
          reasons.push(i18n.t("financial-tools.SbMissingFields").toString());
        }
        if (isInterestOnly) {
          reasons.push(i18n.t("financial-tools.SbInterestOnly").toString());
        }
        if (sd["loan-type"] === MORTGAGE_LOAN_TYPE.SECURED_LOC) {
          reasons.push(i18n.t("financial-tools.SbSecuredLoc").toString());
        }
        const rate = _parseFloat((_sd$interestRate = sd["interest-rate"]) != null ? _sd$interestRate : "");
        if (!isNaN(rate) && (rate < MIN_INTEREST_RATE || rate > MAX_INTEREST_RATE)) {
          reasons.push(i18n.t("financial-tools.SbRateOutOfRange").toString());
        }
        const termMonths = (_parseInt((_sd$termYears = sd["term-years"]) != null ? _sd$termYears : "0") || 0) * 12 + (_parseInt((_sd$termMonths = sd["term-months"]) != null ? _sd$termMonths : "0") || 0);
        const amortMonths = (_parseInt((_sd$amortizationYear = sd["amortization-years"]) != null ? _sd$amortizationYear : "0") || 0) * 12 + (_parseInt((_sd$amortizationMont = sd["amortization-months"]) != null ? _sd$amortizationMont : "0") || 0);
        if (hasTermValue && (termMonths < MIN_PERIOD_MONTHS || termMonths > MAX_PERIOD_MONTHS)) {
          reasons.push(i18n.t("financial-tools.SbTermOutOfRange").toString());
        }
        if (!isInterestOnly && hasAmortizationValue && (amortMonths < MIN_PERIOD_MONTHS || amortMonths > MAX_PERIOD_MONTHS)) {
          reasons.push(i18n.t("financial-tools.SbAmortOutOfRange").toString());
        }
      } else {
        reasons.push(i18n.t("financial-tools.SbMissingFields").toString());
      }
      if ((_acceptedLenderSubmis = acceptedLenderSubmissions.value) != null && _acceptedLenderSubmis[mortgageType]) {
        reasons.push(i18n.t("financial-tools.SbAcceptedLender").toString());
      }
      const totalLoanAmount = (_calculatedValues$tot = calculatedValues == null ? void 0 : calculatedValues.totalLoanAmount) != null ? _calculatedValues$tot : 0;
      if (totalLoanAmount < MIN_MORTGAGE_AMOUNT || totalLoanAmount > MAX_MORTGAGE_AMOUNT) {
        reasons.push(i18n.t("financial-tools.SbAmountOutOfRange").toString());
      }
      return {
        eligible: reasons.length === 0,
        reasons
      };
    }
    function isRowEligible(row) {
      return row.component !== ScenarioBuilderContainer || getScenarioBuilderEligibility(row.selectedMortgageType).eligible;
    }
    function getEligibilityReasons(row) {
      return row.component === ScenarioBuilderContainer ? getScenarioBuilderEligibility(row.selectedMortgageType).reasons : [];
    }
    const ineligibleMortgageTypes = computed(() => _filterInstanceProperty(currentMortgageTypes).call(currentMortgageTypes, mt => !getScenarioBuilderEligibility(mt).eligible));
    const getNumericValue = (value, fallback) => {
      const parsedValue = Number(value);
      return _Number$isFinite(parsedValue) ? parsedValue : fallback;
    };
    const getTotalDownPayment = (downPayments = []) => {
      return _reduceInstanceProperty(downPayments).call(downPayments, (sum, downPayment) => {
        return sum + getNumericValue(downPayment == null ? void 0 : downPayment.amount, 0);
      }, 0);
    };
    const monthlyIncomeFactorByPeriod = {
      [APPLICANT_INCOME_PERIOD.ANNUAL]: 1 / 12,
      [APPLICANT_INCOME_PERIOD.SEMI_ANNUAL]: 1 / 6,
      [APPLICANT_INCOME_PERIOD.QUARTERLY]: 1 / 3,
      [APPLICANT_INCOME_PERIOD.MONTHLY]: 1,
      [APPLICANT_INCOME_PERIOD.SEMI_MONTHLY]: 2,
      [APPLICANT_INCOME_PERIOD.BI_WEEKLY]: 26 / 12,
      [APPLICANT_INCOME_PERIOD.WEEKLY]: 52 / 12
    };
    const getMonthlyIncomeTotal = (entries = []) => {
      return _reduceInstanceProperty(entries).call(entries, (sum, entry) => {
        const amount = getNumericValue(entry["income-amount"] || entry.amount, 0);
        const period = (entry == null ? void 0 : entry["income-period"]) || APPLICANT_INCOME_PERIOD.ANNUAL;
        const factor = monthlyIncomeFactorByPeriod[period] || 0;
        return sum + amount * factor;
      }, 0);
    };
    const getMonthlyLiabilitiesTotal = (liabilities = []) => {
      return _reduceInstanceProperty(liabilities).call(liabilities, (sum, liability) => {
        return sum + getNumericValue(liability == null ? void 0 : liability.payment, 0);
      }, 0);
    };
    const getApplicantsIncomeAndLiabilities = () => {
      const applicants = CURRENT_APPLICATION_APPLICANTS.value;
      return _reduceInstanceProperty(applicants).call(applicants, (totals, applicant) => {
        totals.monthlyIncome += getMonthlyIncomeTotal(applicant.employment);
        totals.monthlyIncome += getMonthlyIncomeTotal(applicant["other-income"]);
        totals.monthlyLiabilities += getMonthlyLiabilitiesTotal(applicant.liabilities);
        return totals;
      }, {
        monthlyIncome: 0,
        monthlyLiabilities: 0
      });
    };
    const initData = {
      clientUsername: props.clientUsername,
      mortgageType: "",
      totalLoanAmount: 0,
      compoundedPeriod: MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY,
      frequency: MORTGAGE_FREQUENCY.MONTHLY,
      interestOnly: false,
      income: 0,
      propertytax: 0,
      heatingcost: 0,
      condofee: 0,
      condoFeesPercentage: 0,
      downpayment: 0,
      interestRate: 0,
      amortizPeriodMths: 0,
      mortgageTerm: 0,
      monthlyDebts: 0,
      prepared_for: "",
      ineligibleMortgageTypes: []
    };
    const activateCalculator = item => {
      var _currentApplication$p, _currentApplication$m;
      const selectedMortgageType = item.selectedMortgageType;
      initData.mortgageType = selectedMortgageType;
      const calculatedValues = CALCULATED_VALUES_BY_MORTGAGE_TYPE.value(selectedMortgageType);
      initData.totalLoanAmount = getNumericValue(calculatedValues == null ? void 0 : calculatedValues.totalLoanAmount, 0);
      const submissionDetail = GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE.value(selectedMortgageType);
      const submissionDetails = submissionDetail["submission-details"] || {};
      initData.frequency = submissionDetails.frequency || MORTGAGE_FREQUENCY.MONTHLY;
      initData.interestOnly = submissionDetails["interest-only"] === true;
      initData.compoundedPeriod = submissionDetails["compounded-period"] || MORTGAGE_COMPOUNDING_PERIOD.SEMI_ANNUALLY;
      const amortYears = getNumericValue(submissionDetails["amortization-years"], 0);
      const amortMonths = getNumericValue(submissionDetails["amortization-months"], 0);
      initData.amortizPeriodMths = amortYears * 12 + amortMonths;
      const termYears = getNumericValue(submissionDetails["term-years"], 0);
      const termMonths = getNumericValue(submissionDetails["term-months"], 0);
      initData.mortgageTerm = termYears * 12 + termMonths;
      const propertyCosts = ((_currentApplication$p = currentApplication.property) == null ? void 0 : _currentApplication$p.costs) || {};
      const {
        monthlyIncome,
        monthlyLiabilities
      } = getApplicantsIncomeAndLiabilities();
      initData.income = monthlyIncome * 12;
      initData.propertytax = getNumericValue(propertyCosts["property-taxes"], initData.propertytax);
      initData.heatingcost = getNumericValue(propertyCosts.heating, initData.heatingcost);
      initData.condofee = getNumericValue(propertyCosts["maintenance-fees"], initData.condofee);
      initData.condoFeesPercentage = getNumericValue(propertyCosts["perc-of-total-maint-fees"], initData.condoFeesPercentage);
      initData.downpayment = getTotalDownPayment((_currentApplication$m = currentApplication["mortgage-details"]) == null ? void 0 : _currentApplication$m["down-payment"]);
      initData.interestRate = getNumericValue(submissionDetails["interest-rate"], initData.interestRate);
      initData.monthlyDebts = monthlyLiabilities;
      initData.prepared_for = CURRENT_APPLICATION_PRINCIPAL_BORROWER.value || initData.prepared_for;
      initData.ineligibleMortgageTypes = ineligibleMortgageTypes.value;
      activeCalculator.value = item;
    };
    return {
      ScenarioBuilderContainer,
      activeCalculator,
      initData,
      calculatorTypeRows,
      mortgageTypeOptionsCur,
      fields,
      handleMortgageTypeSelected,
      activateCalculator,
      isRowEligible,
      getEligibilityReasons
    };
  }
});